import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operativeSpendingComponent from './operative-spending.component';
import ngMessages from 'angular-messages';

let OperativeSpendingModule = angular.module('OperativeSpending', [
    uiRouter,
    ngMessages
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newOperativeSpending', {
            url: '/operative-spendings/new?voucherId&quoteId',
            component: 'operativeSpending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService, EmployeesService) => {
                    return LoginService.getCurrent().then(user => {
                        if (user.employeeId) {
                            return EmployeesService.findById(user.employeeId)
                                .then(employee => {
                                    user.employee = employee;
                                    return user;
                                });
                        } else {
                            return user;
                        }
                    });
                },
                quote: (QuotesService, $stateParams) => {
                    if ($stateParams.quoteId) {
                        return QuotesService.findById($stateParams.quoteId, {
                            include: ['holder', 'vehicle']
                        });
                    }
                }
            }
        })
        .state('editOperativeSpending', {
            url: '/operative-spendings/:id',
            component: 'operativeSpending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                spending: (
                    OperativeSpendingsService,
                    $stateParams
                ) => {
                    return OperativeSpendingsService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [
                                'employee',
                                'collection',
                                'vehicle',
                                {
                                    relation: 'quote',
                                    scope: {
                                        include: [
                                            'holder',
                                            'procedures',
                                            'vehicle'
                                        ]
                                    }
                                },
                                'holder',
                                'voucher',
                                {
                                    relation: 'osItems',
                                    scope: {
                                        include: [
                                            {
                                                relation: 'item',
                                                scope: {
                                                    include: ['procedure']
                                                }
                                            }
                                        ]
                                    }
                                },
                                'createdByUser',
                                'updatedByUser'
                            ],
                            deleted: true
                        }
                    });
                },
                user: (LoginService) => {
                    return LoginService.getCurrent();
                }
            }
        });
})
.component('operativeSpending', operativeSpendingComponent)
.name;

export default OperativeSpendingModule;
